import { PROPOSAL_DATA } from "@proposalaction";
import { PROPOSAL_PROTECTED_PAGE } from "@proposalaction";

export let proposalData = (state = {}, action) => {
  if (action.type === PROPOSAL_DATA) {
    return action.payload;
  }
  return state;
};
export let proposalProtected = (state = {}, action) => {
  if (action.type === PROPOSAL_PROTECTED_PAGE) {
    return action.payload;
  }
  return state;
};
